import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for ActivityStore, for use in the registry */ export const ActivityStoreActionTypes = [
    ActionType.FetchGroupConversationThreadAction,
    ActionType.UpdateUserActivityTimestamp
];
